import { XMarkIcon } from '@heroicons/react/24/outline'
import { Button, Typography } from '@pw-tech/omni-ui'

export default function AssistEarnPopupCard({ isOpen, onClose, setIsOpenGuideModal }: any) {
    return (
        <div className="absolute top-[-175px] md:top-[-195px] left-0 z-50 bg-white p-4 rounded-md w-[360px]">
            <div className='flex flex-col gap-4'>
                <div className="flex justify-between items-start">
                    <div className='flex flex-col gap-[2px]'>
                        <Typography color='#1B2124' variant='subHeading' weight='bold'>
                            Guide a buyer, earn more!
                        </Typography>
                        <Typography color='#3D3D3D' variant='small' weight='medium'>
                            Use this feature to help a student complete their purchase with auto-applied discounts and a higher commission structure.
                        </Typography>
                    </div>
                    <XMarkIcon
                        height={24}
                        className='text-[#1B2124] w-6 h-6 absolute top-2 right-2 cursor-pointer'
                        width={24}
                        onClick={onClose}
                    />
                </div>
                <div className="flex gap-2 flex-wrap justify-end">
                    <Button variant='secondary' size='small' onClick={onClose}>
                        Skip
                    </Button>
                    <Button variant='primary' size='small' onClick={() => {
                        setIsOpenGuideModal(true)
                        onClose()
                    }}>
                        Know More
                    </Button>
                </div>
            </div>
            <div className="absolute bottom-[-8px] left-5 w-4 h-4 bg-white rotate-45" />
        </div>
    )
}
